import { render, staticRenderFns } from "./navLocale.vue?vue&type=template&id=09661088&scoped=true"
import script from "./navLocale.vue?vue&type=script&lang=js"
export * from "./navLocale.vue?vue&type=script&lang=js"
import style0 from "./navLocale.vue?vue&type=style&index=0&id=09661088&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09661088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09661088')) {
      api.createRecord('09661088', component.options)
    } else {
      api.reload('09661088', component.options)
    }
    module.hot.accept("./navLocale.vue?vue&type=template&id=09661088&scoped=true", function () {
      api.rerender('09661088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navBar/navLocale.vue"
export default component.exports